export default class User {
  /**
   * @param id GUID of this user
   * @param authServerId The id of the user on authorization server (it is sent in access token as "sub" property, a.k.a. subject).
   * @param name 
   * @param cpf Main ID in Brazil.
   * @param email 
   * @param mobileNumber 
   */
  constructor(
    public id: string,
    public authServerId: string,
    public name: string,
    public cpf: string,
    public email: string,
    public mobileNumber: string
  ) { }
}